import { createReducer, on } from '@ngrx/store';

import * as CertificationActions from './certification.actions';
import {
  certificationStateAdapter,
  initialCertificationState,
} from './certification.state';

export const reducer = createReducer(
  initialCertificationState,
  on(CertificationActions.certificationsLoadedSuccess, (state, action) =>
    certificationStateAdapter.setAll(action.certifications, state)
  ),
  on(CertificationActions.certificationsLoadedFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(CertificationActions.loadCertifications, () => initialCertificationState),
  on(CertificationActions.clearCertifications, (state) =>
    certificationStateAdapter.removeAll(state)
  )
);
